export default "__VITE_ASSET__BtYO9v3i__"